import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import { FDAlert } from '@facet-wealth/design';
import { useNextUpItemDetailUpdated, useWizardFinished } from 'Hooks/useRefreshEvent';
import { noop } from 'Helpers/PropTypes';
import { Layout as NextUpAccountInfoSectionLayout, metaOverrideSet as nextUpAccountInfoSectionMetaOverrideSet } from './NextUpAccountInfoSection';
import { Layout as NextUpFundingInstructionSectionLayout } from './NextUpFundingInstructionSection';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    overflow: 'auto',
  },
}));

const FacetPlanProposalNextUpAccountDetailItemLayout = ({
  collection,
  refreshCollection,
  setActiveTabResourceType,
}) => {
  const classes = useStyles();

  // Refresh when we update the Next Up Account Detail item
  useNextUpItemDetailUpdated(() => {
    refreshCollection();
  }, [refreshCollection]);

  // Refresh when we finish the DoL wizard
  useWizardFinished(() => {
    refreshCollection();
  }, [refreshCollection]);

  const resource = collection.resources().head();

  const hasOpenAccountItem = resource.attr('accountInfoSection')?.resources().length() > 0;
  const shouldShowFundingInstructions = resource.attr('accountInfoSection')?.resources().head()?.isTruthy('createOnActivation');

  return (
    <div className={classes.root}>
      {hasOpenAccountItem ? <MetaCollectionFormInline
        collection={resource.attr('accountInfoSection')}
        padding="none"
        FormProps={{
          noIndividualSubmitButtons: true,
          layout: NextUpAccountInfoSectionLayout,
        }}
        metaOverrideSet={nextUpAccountInfoSectionMetaOverrideSet}
      /> : null}
      <hr />
      {!hasOpenAccountItem || shouldShowFundingInstructions ? (
        <NextUpFundingInstructionSectionLayout collection={resource.attr('fundingInstructionsSection')} setActiveTabResourceType={setActiveTabResourceType} />
      ) : (
        <FDAlert status="warning" title="Funding instructions will appear once the account open item is selected" />
      )}
    </div>
  );
};

FacetPlanProposalNextUpAccountDetailItemLayout.propTypes = {
  collection: PropTypes.object.isRequired,
  refreshCollection: PropTypes.object.isRequired,
  setActiveTabResourceType: PropTypes.func,
};

FacetPlanProposalNextUpAccountDetailItemLayout.defaultProps = {
  setActiveTabResourceType: noop,
};

export default FacetPlanProposalNextUpAccountDetailItemLayout;
